<template>
  <div class="footer">
    <div class="footer-info">
      <div class="item">
        <div class="footer-logo">
          <img src="@/assets/footer-logo.png" alt="" />
        </div>
        <div class="info">四川时代新成科技有限公司</div>
        <div class="desc">专业企业数字化服务提供商</div>
      </div>
      <div class="footer-item">
        <div class="title" @click="handleOpen('/product')">公司产品</div>
        <div class="text" @click="handleOpen('/product', 'ourProduct')">
          我们的产品
        </div>
        <div class="text" @click="handleOpen('/product', 'productAdvantage')">
          产品优势
        </div>
        <div class="text" @click="handleOpen('/product', 'chooseUs')">
          为什么选择我们？
        </div>
      </div>

      <div class="footer-item">
        <div class="title" @click="handleOpen('/solution')">解决方案</div>
        <div
          class="text"
          @click="handleOpen('/solution', 'solutionMainContent')"
        >
          专业解决方案
        </div>
        <div
          class="text"
          @click="handleOpen('/solution', 'industryApplications')"
        >
          行业应用
        </div>
        <div
          class="text"
          @click="handleOpen('/solution', 'solutionAdvantageList')"
        >
          服务优势
        </div>
      </div>
      <div class="footer-item">
        <div class="title" @click="handleOpen('/service-case')">服务案例</div>
        <div
          class="text"
          @click="handleOpen('/service-case', 'serviceMainContent')"
        >
          成功案例
        </div>
        <div
          class="text"
          @click="handleOpen('/service-case', 'customerReviewsSection')"
        >
          客户评价
        </div>
        <div style="height: 30px"></div>
      </div>
      <div class="footer-item">
        <div class="title" @click="handleOpen('/news')">新闻动态</div>
        <div class="text" @click="handleOpen('/news', 'latestNewsSection')">
          最新资讯
        </div>
        <div class="text" @click="handleOpen('/news', 'newsDynamicSection')">
          新闻动态
        </div>
        <div style="height: 30px"></div>
      </div>
      <div class="footer-item">
        <div class="title" @click="handleOpen('/job-info')">招聘信息</div>
        <div class="text" @click="handleOpen('/job-info', 'jobMainSection')">
          加入我们
        </div>
        <div class="text" @click="handleOpen('/job-info', 'whyChooseSection')">
          公司优势
        </div>
        <div style="height: 30px"></div>
      </div>
      <div class="footer-item">
        <div class="title" @click="handleOpen('/contact-us')">联系我们</div>
        <div
          class="text"
          @click="handleOpen('/contact-us', 'contactMainSection')"
        >
          联系方式
        </div>
        <div class="text" @click="handleOpen('/contact-us', 'messageSection')">
          在线留言
        </div>
        <div style="height: 30px"></div>
      </div>
      <div class="footer-item footer-item-qrcode">
        <div class="qrcode-img">
          <img src="@/assets/qrcode.png" alt="" />
          <div class="qrcode-text">扫码关注</div>
        </div>
        <div class="address-phone">18782210120</div>
        <div class="address-phone">317175193@qq.com</div>
        <div class="address-phone">成都市高新区蜀都中心一期二号楼1704</div>
      </div>
    </div>
    <div class="bootom">
      Copyright © 2018 四川时代新成科技有限公司 版权所有 | 蜀ICP备18032709号-1
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  mounted() {},
  data() {
    return {};
  },

  methods: {
    handleOpen(path, domId) {
      if (path) {
        this.$router
          .push({
            path: path,
          })
          .then(() => {
            setTimeout(() => {
              this.scrollToElement(domId);
            }, 500);
          });
      } else {
        this.scrollToElement(domId);
      }
    },
    scrollToElement(domId) {
      if (domId) {
        // 先滚动到顶部，确保滚动位置重置
        // window.scrollTo({ top: 0, behavior: "instant" });
        const scrollToDom = () => {
          const dom = document.getElementById(domId);
          console.log(dom, ">>>");

          if (dom) {
            // 动态获取头部高度，避免写死
            const headerHeight = 80;
            const rect = dom.getBoundingClientRect();
            console.log(rect, "rect");

            let targetTop = rect.top + window.pageYOffset - 80;
            // 确保 targetTop 不小于 0
            targetTop = Math.max(targetTop, 0);
            window.scrollTo({
              top: targetTop,
              behavior: "smooth",
            });
          } else {
            // 如果 dom 还没加载，稍后重试
            setTimeout(scrollToDom, 100);
          }
        };
        this.$nextTick(() => {
          scrollToDom();
        });
      } else {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  display: flex;
  flex-direction: column;
  // width: 1440px;

  margin: 0 auto;
  .footer-info {
    flex: 1;
    padding: 48px 160px 10px 160px;
    display: flex;
    // align-items: center;
    justify-content: space-between;
    // gap: 180px;

    .item {
      .footer-logo {
        width: 164px;
        height: 60px;
        margin-bottom: 30px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .info {
        font-size: 18px;
        color: #ffffff;
        margin-bottom: 10px;
      }
      .desc {
        font-size: 14px;
        color: #ffffff;
      }
    }
    .footer-item {
      // margin-top: -10px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
    }
    .footer-item-qrcode {
    }

    .qrcode-img {
      width: 120px;
      height: 120px;
      margin-bottom: 42px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .qrcode-text {
      text-align: center;
      font-size: 16px;
      color: #ffffff;
    }

    .title {
      font-size: 16px;
      color: #ffffff;
      margin-bottom: 30px;
      cursor: pointer;
      &:hover {
        color: #1e74ff;
      }
    }
    .text {
      font-size: 14px;
      color: rgb(255, 255, 255, 0.5);
      margin-bottom: 10px;
      cursor: pointer;
      &:hover {
        color: #1e74ff;
      }
    }
    .address-phone {
      font-size: 14px;
      color: rgb(255, 255, 255, 0.5);
      margin-bottom: 10px;
    }
  }

  .bootom {
    width: 100%;
    // height: 57px;
    text-align: center;
    border-top: 1px solid rgb(255, 255, 255, 0.1);
    padding: 20px 0;
    background: #212121;
    font-size: 12px;
    color: rgb(255, 255, 255, 0.5);
  }
}

// @media (max-width: 1440px) {
//   .footer {
//     width: 1440px !important;
//   }
//   .footer-info {
//     width: 1440px;
//     margin: 0 auto;
//     background: #212121;
//     gap: 120px !important;
//     .item:first-child {
//       padding-left: 160px;
//     }
//   }
// }
// @media (min-width: 1200px) and (max-width: 1599px) {
//   .footer-info {
//     width: 1440px;
//     margin: 0 auto;
//     background: #212121;
//     gap: 80px !important;
//     .item:first-child {
//       padding-left: 160px;
//     }
//   }
// }
// @media (min-width: 1600px) and (max-width: 1919px) {
//   .footer-info {
//     width: 1440px;
//     margin: 0 auto;
//     background: #212121;
//     gap: 120px !important;
//     .item:first-child {
//       padding-left: 160px;
//     }
//   }
// }

// /* （1920px及以上） */
// @media (min-width: 1920px) {
//   .footer {
//     width: 1600px;
//     margin: 0 auto;
//   }
// }
</style>
